import { Divider } from "@mui/joy";
import { motion } from "framer-motion";
import { useTheme } from "next-themes";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../utils/supabase";
const Auth = () => {
  const [displayName, setDisplayName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSignup, setIsSignup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { resolvedTheme } = useTheme();
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.setItem("theme", resolvedTheme);
  }, [resolvedTheme]);
  async function signUpNewUser(e) {
    e.preventDefault();
    setIsLoading(true);
    if (displayName.length === 0) {
      enqueueSnackbar("Please enter a name", { variant: "error" });
      setIsLoading(false);
      return;
    }
    const { data, error } = await supabase.auth.signUp({
      options: {
        data: {
          name: displayName,
          weightUnit: "metric",
        },
      },
      email: email,
      password: password,
    });

    if (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      setIsLoading(false);
    } else {
      setIsLoading(false);
      enqueueSnackbar("Sign up successful", { variant: "success" });
      navigate("/home", { replace: true });
    }
  }
  async function signIn(e) {
    e.preventDefault();
    setIsLoading(true);
    const { data, error } = await supabase.auth.signInWithPassword({
      email: email,
      password: password,
    });

    if (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      setIsLoading(false);
    } else {
      setIsLoading(false);
      navigate("/home", { replace: true });
      enqueueSnackbar("Sign in successful!", { variant: "success" });
    }
  }

  async function handleDemoUserSignIn(e) {
    e.preventDefault();
    setIsLoading(true);
    const { data, error } = await supabase.auth.signInWithPassword({
      email: "demo@demo.com",
      password: "demo123",
    });

    if (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      setIsLoading(false);
    } else {
      setIsLoading(false);
      navigate("/home", { replace: true });

      enqueueSnackbar("Sign in successful!", { variant: "success" });
    }
  }

  async function signInWithOAuth() {
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo: `${import.meta.env.VITE_APP_URL}/home`,
      },
    });
    localStorage.setItem("weightUnit", "metric");

    if (error) {
      enqueueSnackbar(error.message, { variant: "error" });
    }
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, x: "100vw" }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <div className="flex flex-1 flex-col justify-center items-stretch px-3 h-[calc(100vh_-_2rem)] w-full">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 512"
            width="45"
            height="35"
            className="inline"
          >
            <path
              fill="#4f46e5"
              d="M96 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V224v64V448c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V384H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H96V64zm448 0v64h32c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32v64c0 17.7-14.3 32-32 32H544v64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V288 224 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32zM416 224v64H224V224H416z"
            />
          </svg>

          <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight  text-gray-900 dark:text-slate-200">
            {isSignup ? "Sign up for a new account" : "Sign in to your account"}
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <form className="space-y-6" action="#" method="POST">
            {isSignup && (
              <div>
                <label
                  htmlFor="displayName"
                  className="block text-sm font-medium leading-6 text-gray-900 dark:text-slate-200 text-left"
                >
                  Name
                </label>
                <div className="mt-2">
                  <input
                    id="displayName"
                    name="displayName"
                    type="text"
                    autoComplete="displayName"
                    required
                    value={displayName}
                    onChange={(e) => {
                      setDisplayName(e.target.value);
                    }}
                    onKeyDown={(event) => {
                      if (!/[a-zA-Z\s]/i.test(event.key)) {
                        event.preventDefault();
                        enqueueSnackbar("Name can only contain letters", {
                          variant: "error",
                        });
                      }
                    }}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-slate-200 dark:bg-inherit shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>
            )}
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium leading-6 text-gray-900 dark:text-slate-200 text-left"
              >
                Email address
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-slate-200 dark:bg-inherit shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label
                  htmlFor="password"
                  className="block text-sm font-medium leading-6 text-gray-900 dark:text-slate-200"
                >
                  Password
                </label>
              </div>
              <div className="mt-2">
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 dark:bg-inherit dark:text-slate-200 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div>
              <button
                disabled={isLoading}
                onClick={async (e) => {
                  try {
                    if (!isSignup) {
                      await signIn(e);
                    } else {
                      await signUpNewUser(e);
                    }
                  } catch (error) {
                    enqueueSnackbar(error.message, { variant: "error" });
                  }
                }}
                className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                {isLoading && (
                  <svg
                    aria-hidden="true"
                    role="status"
                    className="inline w-4 h-6 text-white animate-spin items-center justify-center"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="#E5E7EB"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentColor"
                    />
                  </svg>
                )}

                {!isLoading ? (isSignup ? "Sign up" : "Sign in") : null}
              </button>
              {!isSignup && (
                <button
                  disabled={isLoading}
                  onClick={handleDemoUserSignIn}
                  className="flex w-full justify-center rounded-md bg-indigo-600 px-3 mt-2 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  {isLoading && (
                    <svg
                      aria-hidden="true"
                      role="status"
                      className="inline w-4 h-6 text-white animate-spin items-center justify-center"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="#E5E7EB"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentColor"
                      />
                    </svg>
                  )}
                  {isLoading ? null : "Sign in as a demo user"}
                </button>
              )}
            </div>
          </form>
          {isSignup ? (
            <p className="mt-10 text-center text-sm text-gray-500 dark:text-gray-300">
              Already have an account?{" "}
              <a
                onClick={() => setIsSignup(false)}
                className="font-semibold leading-6 text-indigo-600 hover:text-indigo-500 cursor-pointer"
              >
                Sign in
              </a>
            </p>
          ) : (
            <p className="mt-10 text-center text-sm text-gray-500 dark:text-gray-300">
              Not a member?{" "}
              <a
                onClick={() => {
                  setIsSignup(true);
                }}
                className="font-semibold leading-6 text-indigo-600 dark:text-indigo-400 hover:text-indigo-500 cursor-pointer"
              >
                Sign up
              </a>
            </p>
          )}
          <div className="flex flex-col items-center justify-center mt-10">
            <span className="text-gray-900 dark:text-slate-200">
              {" "}
              <Divider
                sx={{
                  width: {
                    xs: "15rem",
                    md: "20rem",
                    lg: "20rem",
                    sm: "20rem",
                  },
                  marginBottom: 3,
                  alignSelf: "center",
                }}
                orientation="horizontal"
              >
                {" "}
                Or continue with{" "}
              </Divider>
            </span>

            <button
              onClick={signInWithOAuth}
              className="px-4 py-2 border flex gap-2 border-slate-200 dark:border-slate-700 rounded-lg text-slate-700 dark:text-slate-200 hover:border-slate-400 dark:hover:border-slate-500 hover:text-slate-900 dark:hover:text-slate-300 hover:shadow transition duration-150"
            >
              <img
                className="w-6 h-6"
                src="https://www.svgrepo.com/show/475656/google-color.svg"
                loading="lazy"
                alt="google logo"
              ></img>
              <span>Google</span>
            </button>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Auth;
